import React from 'react';
import { Button, Drawer,Descriptions,Typography,Tag} from 'antd';

import ReactJson from 'react-json-view';

import {
  RightOutlined
} from '@ant-design/icons';
const { Text, Link } = Typography;



const MlView = (props) => {
  const { visible, onClose,info } = props;

  const {additional_models} = info;

  const extra_models = (additional_models ? JSON.parse(additional_models) : {});


  console.log(extra_models);

  return (
    <div className="site-drawer-render-in-current-wrapper">
      <Drawer
        title="Ml-Model Information"
        placement="right"
        width={800}
        closable={true}
        onClose={onClose}
        visible={visible}
        getContainer={false}
        
      >
         <Descriptions bordered column={1} layout="vertical">
          {Object.entries(info).map(([key, value]) => (
            key!=="id" && key!=="live_sync" && key!=="additional_models" ?
            <Descriptions.Item label={<><RightOutlined /> {key}</>} key={key}>
             {(key.indexOf("_model")!==-1 ? <Link href={value} target="_blank">
             
       {value}
    </Link> :  <Tag color="cyan">{value}</Tag>  )  }
               
            </Descriptions.Item>
          : ""))}


           <Descriptions.Item label={<><RightOutlined /> additional_models</>} key="additional_models">
              <ReactJson collapsed={2} name={false} src={extra_models} />
           </Descriptions.Item>
      
        </Descriptions> 

      
      </Drawer>
    </div>
  );
};

export default MlView;
